/**
 * Created by jv on 15/05/2018.
 */

//  Import created game scenes.
import * as scenes from "Sources/games/chicken-game/scenes";

const config = {
  title: "chicken-game",
  version: "0.0.1",
  url: null,

  /*
    - `WEBGL`: Use WebGL rendering;
    - `CANVAS`: Use 'context2D API rendering method;
    - `AUTO`: Phaser will choose, based on device capabilities, the best rendering method to be used.
   */
  type: Phaser.AUTO,
  width: 960,
  height: 540,
  zoom: 1,
  resolution: 1,

  // Whether to disable antialiasing or not. Great for pixel art.
  pixelArt: false,
  // Whether to enable canvas transparency or not.
  transparent: false,

  canvasStyle: "display: block; margin: 0 auto;",
  backgroundColor: "#ffffff",

  //physics: {
    /*
      - `arcade`: Phaser Arcade Physics 2;
      - `matter`: Liam Brummitt's (@liabru) Matter.js;
      - `impact`: ImpactJS Physics Engine.
     */
  /*  default: false
  },*/

  // loader: {
    // path: "assets/games/carrot-game/"
  // },

  // scene: Object.values(scenes)
  scene: Object.keys(scenes).map((key) => scenes[key])
};

export default config;



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/config/phaser.js